import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Directive({
    selector: '[appDisabledPermission]',
    standalone: false,
})
export class DisabledPermissionDirective implements OnInit {
    private el = inject(ElementRef);
    private permissionsService = inject(PermissionsService);

    @Input('appDisabledPermission') public permissions: string;

    public ngOnInit() {
        const permissions = this.permissions.split(',').map((p) => p.trim());

        if (this.permissionsService.hasPermissions(permissions)) {
            if (this.el.nativeElement.disabled === false) {
                this.el.nativeElement.classList.remove('disabled');
                this.el.nativeElement.disabled = false;
            }
        } else {
            this.el.nativeElement.classList.add('disabled');
            this.el.nativeElement.disabled = true;
        }
    }
}
